import React, { useEffect, useRef } from 'react'
import { scroll, motion } from "framer-motion/dom";
import { useTranslation } from 'react-i18next';

function VideoBanner() {

  const { t } = useTranslation()
    
    const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    // Pause the video ini tially
    video.pause();

    // Add a scroll event listener to scrub through the video
    const handleScroll = () => {
      const progress = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (video.readyState) {
        video.currentTime = video.duration * progress;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section className="section videoBanner">
        <h1 dangerouslySetInnerHTML={{ __html: t('banner') }} />
        <div className ="videoBanner__video">
            <video
                ref={videoRef}
                muted
                playsinline
                loop
                src="https://res.cloudinary.com/dvvsyxugn/video/upload/v1691738458/accelerated_earth_blmany.mp4"
            ></video>
        </div>
    </section>
  )
}

export default VideoBanner